import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class BookingStatusModel extends BaseModel {

    constructor(source?: BookingStatusModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._bookingStatusID = 0;
        }
    }

// private properties
    _bookingStatusID: number = 0;
    _bookingStatusName: string = "";

// public properties
    public get bookingStatusID(): number
    {
        return this._bookingStatusID;
    }
    public set bookingStatusID(v: number)
    {
        if (v !== this._bookingStatusID)
        {
            this._bookingStatusID = v;
            this.propertyChanged.emit(new propertyChangedArguments("bookingStatusID", this));
        }
    }

    public get bookingStatusName(): string
    {
        return this._bookingStatusName;
    }
    public set bookingStatusName(v: string)
    {
        if (v !== this._bookingStatusName)
        {
            this._bookingStatusName = v;
            this.propertyChanged.emit(new propertyChangedArguments("bookingStatusName", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: BookingStatusModel): void {
        if (source == null) return;
        this._bookingStatusID = source.bookingStatusID;
        this._bookingStatusName = source.bookingStatusName;
    }


}
